import React, { useCallback, useState, useEffect } from 'react';
import {Heading, Form, FormControl, Select, Flex, TextInput, Box} from '@contentful/f36-components';
import { css } from 'emotion';
import { useSDK } from '@contentful/react-apps-toolkit';

const ConfigScreen = () => {
  const [parameters, setParameters] = useState({
    entraClientId: '',
    entraTenantId: '',
    environment: 'std',
  });
  const sdk = useSDK();
  const onConfigure = useCallback(async () => {
    console.log(parameters);
    // This method will be called when a user clicks on "Install"
    // or "Save" in the configuration screen.
    // for more details see https://www.contentful.com/developers/docs/extensibility/ui-extensions/sdk-reference/#register-an-app-configuration-hook

    // Get current the state of EditorInterface and other entities
    // related to this app installation
    const currentState = await sdk.app.getCurrentState();
    console.log('Current state:', currentState);
    return {
      // Parameters to be persisted as the app configuration.
      parameters,
      // In case you don't want to submit any update to app
      // locations, you can just pass the currentState as is
      targetState: currentState,
    };
  }, [parameters, sdk]);

  useEffect(() => {
    // `onConfigure` allows to configure a callback to be
    // invoked when a user attempts to install the app or update
    // its configuration.
    sdk.app.onConfigure(() => onConfigure());
  }, [sdk, onConfigure]);

  useEffect(() => {
    (async () => {
      // Get current parameters of the app.
      // If the app is not installed yet, `parameters` will be `null`.
      const currentParameters = await sdk.app.getParameters();
      console.log('Current params:', currentParameters);
      if (currentParameters) {
        setParameters(currentParameters);
      }
      // Once preparation has finished, call `setReady` to hide
      // the loading screen and present the app to a user.
      sdk.app.setReady();
    })();
  }, [sdk]);

  const onClientIdChange = (event) => {
    setParameters({ ...parameters, entraClientId: event.target.value })
  }

  const onTenantIdChange = (event) => {
    setParameters({ ...parameters, entraTenantId: event.target.value })
  }

  const onEnvironmentChange = (event) => {
    setParameters({ ...parameters, environment: event.target.value })
  }

  return (
    <Flex flexDirection="column" className={css({ margin: '80px', maxWidth: '800px' })}>
      <Heading>Configuration</Heading>
      <Form onSubmit={() => {}}>
        <FormControl>
          <FormControl.Label isRequired>Entra Client ID</FormControl.Label>
          <TextInput value={parameters.entraClientId} onChange={onClientIdChange} />
          <FormControl.HelpText>
            Entra Client ID is a unique identifier for your Entra account.
          </FormControl.HelpText>
        </FormControl>

        <FormControl>
          <FormControl.Label isRequired>Entra Tenant ID</FormControl.Label>
          <TextInput value={parameters.entraTenantId} onChange={onTenantIdChange} />
          <FormControl.HelpText>
            Entra Tenant ID is a authentication endpoint for your Entra account.
          </FormControl.HelpText>
        </FormControl>

        <FormControl>
          <FormControl.Label>Environment</FormControl.Label>
          <Box>
            <Select
                id="optionSelect-controlled"
                onChange={onEnvironmentChange}
                value={parameters.environment}
                name="optionSelect-controlled">
              <Select.Option value="std">STD</Select.Option>
              <Select.Option value="uat">UAT</Select.Option>
              <Select.Option value="prod">PROD</Select.Option>
            </Select>
          </Box>
          <FormControl.HelpText>Tell me about yourself</FormControl.HelpText>
        </FormControl>
      </Form>
    </Flex>
  );
};
export default ConfigScreen;
